module.exports = "/images/claim_organization_2.jpg?628d0f773238b8cc192568250266d10a";